import { useEffect, useRef } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SectionTimeline from '../../components/feature/SectionTimeline';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import UXJourney from './components/UXJourney';
import DesignPhilosophy from './components/DesignPhilosophy';
import Interests from './components/Interests';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';

export default function Home() {
  const sectionsRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scale-100', 'opacity-100');
            entry.target.classList.remove('scale-92', 'opacity-80');
          } else {
            entry.target.classList.add('scale-92', 'opacity-80');
            entry.target.classList.remove('scale-100', 'opacity-100');
          }
        });
      },
      { threshold: 0.3, rootMargin: '-10% 0px -10% 0px' }
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const addToRefs = (el: HTMLDivElement | null) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  return (
    <div className="relative min-h-screen bg-slate-50 overflow-x-hidden">
      <Navigation />
      <SectionTimeline />
      
      {/* Main Content */}
      <main className="relative z-10 lg:pr-48">
        <div ref={addToRefs} className="transition-all duration-700 ease-out scale-100 opacity-100">
          <Hero />
        </div>
        <div ref={addToRefs} className="transition-all duration-700 ease-out scale-92 opacity-80">
          <Projects />
        </div>
        <div ref={addToRefs} className="transition-all duration-700 ease-out scale-92 opacity-80">
          <Testimonials />
        </div>
        <div ref={addToRefs} className="transition-all duration-700 ease-out scale-92 opacity-80">
          <About />
        </div>
        <div ref={addToRefs} className="transition-all duration-700 ease-out scale-92 opacity-80">
          <UXJourney />
        </div>
        <div ref={addToRefs} className="transition-all duration-700 ease-out scale-92 opacity-80">
          <DesignPhilosophy />
        </div>
        <div ref={addToRefs} className="transition-all duration-700 ease-out scale-92 opacity-80">
          <Skills />
        </div>
        <div ref={addToRefs} className="transition-all duration-700 ease-out scale-92 opacity-80">
          <Interests />
        </div>
        <div ref={addToRefs} className="transition-all duration-700 ease-out scale-92 opacity-80">
          <Contact />
        </div>
      </main>

      <Footer />
    </div>
  );
}
